import { motion } from "framer-motion";
import { ArrowRight, CheckCircle, Zap, Lock } from "lucide-react";
import React from "react";

interface ActionButtonProps {
  onClick: () => void;
  text: string;
  status: "purchased" | "enabled" | "disabled" | "expired";
}

export const ActionButton: React.FC<ActionButtonProps> = ({
  onClick,
  text,
  status,
}) => {
  const role = window.localStorage.getItem("role");

  const getStatusStyles = (
    status: "purchased" | "enabled" | "disabled" | "expired"
  ) => {
    if (role !== "0") {
      switch (status) {
        case "purchased":
          return {
            background: "bg-gradient-to-r from-emerald-500 to-teal-500",
            hoverBg: "hover:from-emerald-600 hover:to-teal-600",
            icon: <CheckCircle className="w-5 h-5" />,
            text: "Access Product",
          };
        case "enabled":
          return {
            background: "bg-gradient-to-r from-indigo-800 to-purple-600",
            hoverBg: "hover:from-indigo-600 hover:to-purple-600",
            icon: <Zap className="w-5 h-5" />,
            text: "Go to Product",
          };
        case "expired":
          return {
            background: "bg-gradient-to-r from-red-500 to-orange-500",
            hoverBg: "hover:from-red-600 hover:to-orange-600",
            icon: <Lock className="w-5 h-5" />,
            text: "View Details of Product",
          };
        default:
          return {
            background: "bg-gradient-to-r from-gray-600 to-gray-700",
            hoverBg: "hover:from-gray-700 hover:to-gray-800",
            icon: <Lock className="w-5 h-5" />,
            text: "View Details of Product",
          };
      }
    } else {
      return {
        background: "bg-gradient-to-r from-indigo-800 to-purple-600",
        hoverBg: "hover:from-indigo-600 hover:to-purple-600",
        icon: <Zap className="w-5 h-5" />,
        text: "Go to Product",
      };
    }
  };

  const styles = getStatusStyles(status);

  return (
    <motion.button
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      onClick={onClick}
      className={`
        w-full py-3 px-6 
        ${styles.background}
        ${styles.hoverBg}
        text-white rounded-lg font-medium 
        flex items-center justify-center gap-3 
        transition-all duration-200
        shadow-lg hover:shadow-xl
        group
      `}
    >
      {styles.icon}
      <span>{styles.text}</span>
      <ArrowRight className="w-5 h-5 opacity-75 group-hover:translate-x-1 transition-transform" />
    </motion.button>
  );
};
